<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <div style="display: flex;margin-top: 2px">
                    <el-button type="primary" size="mini" @click.native="expSum">{{$t('getapi[6952]')}}</el-button>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            action=""
                            :on-preview="handlePreview4"
                            :on-remove="handleRemove4"
                            :on-change="handleChange4"
                            :on-success="handleSuccess4"
                            :on-error="handleError4"
                            :http-request="uploadFile4"
                            :auto-upload="true"
                            style="margin-left: 8px;"
                    >
                        <el-button type="primary" size="mini">{{$t('getapi[6953]')}}
                        </el-button>
                    </el-upload>
                </div>
                <el-tabs :tab-position="'top'" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[945]')" name="0">
                        <el-table
                                id="xpane-0"
                                :data="dataSet"
                                ref="singleTable"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChangeView"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_No" :label="$t('getapi[6919]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[6920]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="PurOrder_No" :label="$t('getapi[1710]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="SalOrder_No" :label="$t('getapi[2291]')"></el-table-column>
                            <el-table-column prop="Status" :label="$t('getapi[552]')">
                                <template scope="scope">
                                    {{expStatus(scope.row.Status)}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[3856]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Person_Dept" :label="$t('getapi[6041]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[4126]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Time" :label="$t('getapi[1210]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Traffic_Type" :label="$t('getapi[6954]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Traffic_Mode" :label="$t('getapi[6923]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Airlift_No" :label="$t('getapi[6955]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Airlift_Url" :label="$t('getapi[6956]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Airlift_Cost" :label="$t('getapi[6957]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Expect_PickTime" :label="$t('getapi[6958]')">
                                <template slot-scope="scope">
                                    {{scope.row.Expect_PickTime | toDate}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Require_ArrivalTime" :label="$t('getapi[6959]')">
                                <template slot-scope="scope">
                                    {{scope.row.Require_ArrivalTime | toDate}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Scheme_No" :label="$t('getapi[6960]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Notice_Date" :label="$t('getapi[6961]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="ToPort_Date" :label="$t('getapi[6962]')"></el-table-column>
                            <!--<el-table-column show-overflow-tooltip prop="Release_Date" label="放行日期"></el-table-column>-->
                            <el-table-column show-overflow-tooltip prop="ToFactory_Date" :label="$t('getapi[6963]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="PayTaxes_Date" :label="$t('getapi[6964]')"></el-table-column>
                            <el-table-column prop="Import_Tariff" :label="$t('getapi[6965]')" align="right">
                                <template slot-scope="scope">
                                    {{scope.row.Import_Tariff | thousandth}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Import_VAT" :label="$t('getapi[6966]')" align="right">
                                <template slot-scope="scope">
                                    {{scope.row.Import_VAT | thousandth}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Domestic_Cost" :label="$t('getapi[6967]')" align="right">
                                <template slot-scope="scope">
                                    {{scope.row.Domestic_Cost | thousandth}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Abroad_Cost" :label="$t('getapi[6968]')" align="right">
                                <template slot-scope="scope">
                                    {{scope.row.Abroad_Cost | thousandth}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_Code" :label="$t('getapi[1196]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Name" :label="$t('getapi[546]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Code" :label="$t('getapi[876]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_Code" :label="$t('getapi[2610]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Quantity" :label="$t('getapi[6944]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Weight" :label="$t('getapi[138]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Tracking_NO" :label="$t('getapi[6969]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Invoice_No" :label="$t('getapi[2992]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Unusual_Cost_Time" :label="$t('getapi[6970]')"></el-table-column>
                            <el-table-column prop="Unusual_Cost_Url" :label="$t('getapi[6971]')">
                                <template scope="scope">
                                    <a v-if="scope.row.Unusual_Cost_Url != '' && scope.row.Unusual_Cost_Url != null" @click="open(scope.row.Unusual_Cost_Url)" style="text-decoration:underline;color:blue">查看文件</a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Invoice_Flag" :label="$t('getapi[8537]')">
                                <template scope="scope">
                                    {{scope.row.Invoice_Flag == true?$t('getapi[2052]'):$t('getapi[2053]')}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6362]')" name="1">
                        <el-table
                                id="xpane-1"
                                :data="personData"
                                ref="singleTable1"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChangeView"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_No" :label="$t('getapi[6919]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[6920]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="PurOrder_No" :label="$t('getapi[1710]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="SalOrder_No" :label="$t('getapi[2291]')"></el-table-column>
                            <el-table-column prop="Status" :label="$t('getapi[552]')">
                                <template scope="scope">
                                    {{expStatus(scope.row.Status)}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[3856]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Person_Dept" :label="$t('getapi[6041]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[4126]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Modify_Time" :label="$t('getapi[1210]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Traffic_Type" :label="$t('getapi[6954]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Traffic_Mode" :label="$t('getapi[6923]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Airlift_No" :label="$t('getapi[6955]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Airlift_Url" :label="$t('getapi[6956]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Airlift_Cost" :label="$t('getapi[6957]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Expect_PickTime" :label="$t('getapi[6958]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Require_ArrivalTime" :label="$t('getapi[6959]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Scheme_No" :label="$t('getapi[6960]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Notice_Date" :label="$t('getapi[6961]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="ToPort_Date" :label="$t('getapi[6962]')"></el-table-column>
                            <!--<el-table-column show-overflow-tooltip prop="Release_Date" label="放行日期"></el-table-column>-->
                            <el-table-column show-overflow-tooltip prop="ToFactory_Date" :label="$t('getapi[6963]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="PayTaxes_Date" :label="$t('getapi[6964]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Import_Tariff" :label="$t('getapi[6965]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Import_VAT" :label="$t('getapi[6966]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Domestic_Cost" :label="$t('getapi[6967]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Abroad_Cost" :label="$t('getapi[6968]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Vender_Code" :label="$t('getapi[1196]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Name" :label="$t('getapi[546]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Code" :label="$t('getapi[876]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Customer_Code" :label="$t('getapi[2610]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Quantity" :label="$t('getapi[6944]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Weight" :label="$t('getapi[138]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Tracking_NO" :label="$t('getapi[6969]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Invoice_No" :label="$t('getapi[2992]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Unusual_Cost_Time" :label="$t('getapi[6970]')"></el-table-column>
                            <el-table-column prop="Unusual_Cost_Url" :label="$t('getapi[6971]')">
                                <template scope="scope">
                                    <a v-if="scope.row.Unusual_Cost_Url != '' && scope.row.Unusual_Cost_Url != null" @click="open(scope.row.Unusual_Cost_Url)" style="text-decoration:underline;color:blue">查看文件</a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Invoice_Flag" :label="$t('getapi[8537]')">
                                <template scope="scope">
                                    {{scope.row.Invoice_Flag == true?$t('getapi[2052]'):$t('getapi[2053]')}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="display: flex;">
                    <el-button type="primary" size="mini" @click.native="email" :disabled="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3">{{$t('getapi[6938]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="setStatus(1)" :disabled="!btn.submit">{{$t('getapi[6468]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="unusualSetStatus(1)" :disabled="!btn.unusualsubmit">{{$t('getapi[6939]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="recall" :disabled="dataDetail.Master.Status != 1">{{$t('getapi[6940]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="setStatus(4)" :disabled="!btn.close">{{$t('getapi[441]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="setStatus(5)" :disabled="!btn.close || dataDetail.Master.Status == 1 || dataDetail.Master.Status == 2">{{$t('getapi[1902]')}}</el-button>
                    <el-button type="primary" size="mini" @click.native="expCostJustOrder" :disabled="dataDetail.Master.PurOrder_No == '' || dataDetail.Master.Import_Tariff ==''">{{$t('getapi[6972]')}}</el-button>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            action=""
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :http-request="uploadFile"
                            :auto-upload="true"
                            style="margin-left: 8px;"
                    >
                        <el-button type="primary" size="mini">{{$t('getapi[6953]')}}
                        </el-button>
                    </el-upload>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            action=""
                            :on-preview="handlePreview1"
                            :on-remove="handleRemove1"
                            :on-change="handleChange1"
                            :on-success="handleSuccess1"
                            :on-error="handleError1"
                            :http-request="uploadFile1"
                            :auto-upload="true"
                            style="margin-left: 8px;"
                    >
                        <el-button type="primary" size="mini">{{$t('getapi[6973]')}}
                        </el-button>
                    </el-upload>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            action=""
                            :on-preview="handlePreview3"
                            :on-remove="handleRemove3"
                            :on-change="handleChange3"
                            :on-success="handleSuccess3"
                            :on-error="handleError3"
                            :http-request="uploadFile3"
                            :auto-upload="true"
                            style="margin-left: 8px;"
                    >
                        <el-button type="primary" size="mini">{{$t('getapi[6974]')}}
                        </el-button>
                    </el-upload>
                    <el-button type="primary" size="mini" @click.native="copy" :disabled="dataDetail.Master.Exclusively_ID == 0" style="margin-left: 8px">{{$t('getapi[35]')}}</el-button>
                </div>
                <div>
                    <el-tabs :tab-position="'top'" type="">
                        <el-tab-pane :label="$t('getapi[6053]')">
                            <table>
                                <tr>
                                    <td style="width:60px">{{$t('getapi[6919]')}}</td>
                                    <td style="width:150px;">
                                        <el-input v-model="dataDetail.Master.Doc_No" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                    </td>

                                    <td style="width:60px">{{$t('getapi[552]')}}</td>
                                    <td style="width:150px;">
                                        <el-input :value="expStatus(dataDetail.Master.Status)" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td style="width:60px">{{$t('getapi[6942]')}}</td>
                                    <td style="width:150px;">
                                        <el-input :value="expStatus(dataDetail.Master.UCStatus)" type="text" size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td >{{$t('getapi[410]')}}</td>
                                    <td >
                                        <el-input v-model="dataDetail.Master.Create_Person" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td >{{$t('getapi[6975]')}}</td>
                                    <td >
                                        <el-input v-model="dataDetail.Master.Create_Person_Dept" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td>{{$t('getapi[135]')}}</td>
                                    <td>
                                        <el-date-picker v-model="dataDetail.Master.Create_Time" type="datetime" size="mini"
                                                        style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[733]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Modify_Person" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td>{{$t('getapi[1210]')}}</td>
                                    <td>
                                        <el-date-picker v-model="dataDetail.Master.Modify_Time" type="datetime" size="mini"
                                                        style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                    </td>
                                    <td>{{$t('getapi[6960]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Scheme_No" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[6938]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Notice_Log" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td>{{$t('getapi[6269]')}}</td>
                                    <td>
                                        <el-date-picker v-model="dataDetail.Master.Notice_time" type="datetime" size="mini"
                                                        style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                    </td>
                                    <td>{{$t('getapi[1976]')}}</td>
                                    <td>
                                        <el-select v-model="dataDetail.Master.Return_Flag">
                                            <el-option :label="$t('getapi[4349]')" :value=0></el-option>
                                            <el-option :label="$t('getapi[12801]')" :value=1></el-option>
                                            <el-option :label="$t('getapi[12802]')" :value=2></el-option>
                                        </el-select>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="6">
                                        <el-divider content-position="left">{{$t('getapi[6943]')}}</el-divider>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[1710]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.PurOrder_No" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="textarea" size="mini" :readonly="true" class="readO"></el-input>
                                        <el-input v-model="dataDetail.Master.PurOrder_No" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" type="textarea" size="mini" class="mcolor"></el-input>
                                    </td>
                                    <!--<td>销售订单号</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.SalOrder_No" type="textarea" size="mini"></el-input>
                                    </td>-->
                                    <td>{{$t('getapi[6954]')}}</td>
                                    <td>
                                        <el-select filterable v-model="dataDetail.Master.Traffic_Type" size="mini" @change="changeTrafficType">
                                            <el-option v-for="item in TrafficTypeArray" :key="item.Code" :label="item.Name"
                                                       :value="item.Code" style="width:100%"></el-option>
                                        </el-select>
                                    </td>
                                    <td>{{$t('getapi[6958]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Expect_PickTime" v-if="dataDetail.Master.Status != 0  && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                        <el-date-picker v-model="dataDetail.Master.Expect_PickTime" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="date" size="mini"
                                                        style="width:100%"></el-date-picker>
                                    </td>
                                </tr>
                                <!--<tr>
                                    <td>运输方式</td>
                                    <td>
                                        <el-select filterable v-model="dataDetail.Master.Traffic_Mode" size="mini">
                                            <el-option v-for="item in TrafficModeArray" :key="item.Code" :label="item.Name"
                                                       :value="item.Code" style="width:100%"></el-option>
                                        </el-select>
                                    </td>
                                    <td>空运申请单</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Airlift_No" type="text" size="mini" :disabled="dataDetail.Master.Traffic_Type == '海运'"></el-input>
                                    </td>
                                    <td>高速/空运费用</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Airlift_Cost" type="number" autocomplete="off" title="" size="mini" :disabled="dataDetail.Master.Traffic_Type == '海运'  || dataDetail.Master.Status==2 || dataDetail.Master.Status==4" @mousewheel.native.prevent></el-input>
                                    </td>
                                </tr>-->
                                <tr>
                                    <td>{{$t('getapi[6959]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Require_ArrivalTime" v-if="dataDetail.Master.Status != 0  && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                        <el-date-picker v-model="dataDetail.Master.Require_ArrivalTime" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="date" size="mini"
                                                        style="width:100%"></el-date-picker>
                                    </td>
                                    <td>{{$t('getapi[1196]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Vender_Code" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                        <routejump :urlNo="26" v-if="dataDetail.Master.Return_Flag ==0 && (dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3)">
                                        <el-input
                                                v-model="dataDetail.Master.Vender_Code"
                                                type="text"
                                                readonly
                                                class="mcolor"
                                                size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectVenderCode()"></i>
                                        </el-input>
                                        </routejump>
                                        <el-input v-model="dataDetail.Master.Vender_Code" v-if="dataDetail.Master.Return_Flag != 0 && (dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3)" type="text" size="mini"></el-input>
                                    </td>
                                    <td>{{$t('getapi[1197]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Vender_Name" v-if="dataDetail.Master.Return_Flag != 0 && (dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3)" type="text" size="mini"></el-input>
                                        <el-input v-model="dataDetail.Master.Vender_Name" v-else type="text" size="mini" :readonly="true" class="readO"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[3437]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Item_Code" v-if="dataDetail.Master.Return_Flag != 0 && (dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3)" type="text" size="mini"></el-input>
                                        <el-input v-model="dataDetail.Master.Item_Code" v-else type="text" size="mini" :readonly="true" class="readO"></el-input>
                                        <!--<el-input
                                                v-model="dataDetail.Master.Item_Code"
                                                type="text"
                                                readonly
                                                class="mcolor"
                                                size="mini"
                                                v-if="dataDetail.Master.Status == 0"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectItemCode()"></i>
                                        </el-input>-->
                                    </td>
                                    <td>{{$t('getapi[2610]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Customer_Code" v-if="dataDetail.Master.Return_Flag != 0 && (dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3)" type="text" size="mini"></el-input>
                                        <el-input v-model="dataDetail.Master.Customer_Code" v-else type="text" size="mini" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <!--<td>项目名称</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Item_Name" type="text" size="mini" :disabled="true"></el-input>
                                    </td>-->
                                    <td>{{$t('getapi[6944]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Quantity" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                        <el-input v-model="dataDetail.Master.Quantity" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="text" size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[138]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Weight" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                        <el-input v-model="dataDetail.Master.Weight" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="text" size="mini"></el-input>
                                    </td>
                                    <!--<td>原产国</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Origin_Country" type="text" size="mini"></el-input>
                                    </td>-->
                                    <td>{{$t('getapi[6976]')}}</td>
                                    <td>
                                        <!--<el-input v-model="dataDetail.Master.Liefer_Adress" type="text" size="mini"></el-input>-->
                                        <el-input
                                                v-model="dataDetail.Master.Liefer_Adress"
                                                type="text"
                                                readonly
                                                size="mini"
                                                v-if="dataDetail.Master.Status == 0  || dataDetail.Master.Status == 3"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectLieferAdress()"></i>
                                        </el-input>
                                    </td>
                                    <td>{{$t('getapi[6977]')}}</td>
                                    <td>
                                        <el-checkbox v-model="dataDetail.Master.Urgent_Flag" :true-label='1' :false-label='0'>
                                        </el-checkbox>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[6978]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Airlift_Reason" type="text" size="mini"></el-input>
                                    </td>
                                    <td>{{$t('getapi[6979]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Goods_Value" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="number" autocomplete="off" title="" size="mini" :readonly="true" class="readO"></el-input>
                                        <el-input v-model="dataDetail.Master.Goods_Value" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{$t('getapi[6980]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Goods_Currency" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                        <routejump :urlNo="24" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3">
                                        <el-select filterable v-model="dataDetail.Master.Goods_Currency"  class="mcolor" size="mini">
                                            <el-option v-for="(item, index) in Currency" :label="item.currency_code"
                                                       :value="item.currency_code" :key="index"></el-option>
                                        </el-select>
                                        </routejump>
                                    </td>
                                </tr>
                                <tr>
                                    <!--<td>责任部门编号</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Duty_DeptNum" type="text" size="mini" v-if="dataDetail.Master.Status != 0" :disabled="true"></el-input>
                                        <el-input
                                                v-model="dataDetail.Master.Duty_DeptNum"
                                                type="text"
                                                readonly
                                                class="mcolor"
                                                size="mini"
                                                v-if="dataDetail.Master.Status == 0"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectDutyDeptNum()"></i>
                                        </el-input>
                                    </td>
                                    <td>责任部门名称</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Duty_Dept" type="text" size="mini" :disabled="true"></el-input>
                                    </td>-->
                                    <!--<td>包装尺寸</td>
                                    <td colspan="3">
                                        <el-input v-model="dataDetail.Master.Package_Size" type="textarea" size="mini"></el-input>
                                    </td>-->
                                </tr>
                                <tr>
                                    <td colspan="6">
                                        <el-divider content-position="left">{{$t('getapi[6981]')}}</el-divider>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[6961]')}}</td>
                                    <td>
                                        <el-date-picker v-model="dataDetail.Master.Notice_Date" type="date" size="mini"
                                                        style="width:100%"></el-date-picker>
                                    </td>
                                    <td>{{$t('getapi[6962]')}}</td>
                                    <td>
                                        <el-date-picker v-model="dataDetail.Master.ToPort_Date" type="date" size="mini"
                                                        style="width:100%"></el-date-picker>
                                    </td>
                                    <td>{{$t('getapi[6963]')}}</td>
                                    <td>
                                        <el-date-picker v-model="dataDetail.Master.ToFactory_Date" type="date" size="mini"
                                                        style="width:100%"></el-date-picker>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[6982]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Traffic_Cost" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                        <el-input v-model="dataDetail.Master.Traffic_Cost" v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="dataDetail.Master.Status==2 || dataDetail.Master.Status==4" :class="[dataDetail.Master.Status==2 || dataDetail.Master.Status==4?'readO':'mcolor']"></el-input>
                                    </td>
                                    <td>{{$t('getapi[6983]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Traffic_Cost_Currency" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                        <el-select filterable v-model="dataDetail.Master.Traffic_Cost_Currency " v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3" class="mcolor" size="mini">
                                            <el-option v-for="(item, index) in Currency" :label="item.currency_code"
                                                       :value="item.currency_code" :key="index"></el-option>
                                        </el-select>
                                    </td>
                                    <td>{{$t('getapi[916]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Unit" v-if="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3" type="text" size="mini" :readonly="true" class="readO"></el-input>
                                        <el-input
                                                v-model="dataDetail.Master.Unit"
                                                type="text"
                                                size="mini"
                                                v-if="dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3"
                                                class="mcolor"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectUnit()"></i>
                                        </el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[2992]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Invoice_No" type="text" size="mini"></el-input>
                                    </td>
                                    <td>{{$t('getapi[143]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Remark" type="text" size="mini"></el-input>
                                    </td>
                                    <!--<td>采购合同上传时间</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Pur_Contract_Time" type="text" size="mini"></el-input>
                                    </td>
                                    <td>采购合同上传地址</td>
                                    <td>
                                        <a v-if="dataDetail.Master.Pur_Contract_Url != null && dataDetail.Master.Pur_Contract_Url != ''" @click="open(dataDetail.Master.Pur_Contract_Url)" style="text-decoration:underline;color:blue">查看采购合同</a>
                                        &lt;!&ndash;<el-input v-model="dataDetail.Master.Pur_Contract_Url" type="text" size="mini" :disabled="true"></el-input>&ndash;&gt;
                                    </td>-->
                                </tr>
                                <tr>
                                    <td colspan="6">
                                        <el-divider content-position="left">{{$t('getapi[6984]')}}</el-divider>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[6985]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Track_Num" type="text" size="mini" :readonly="dataDetail.Master.Status==4" :class="{'readO':dataDetail.Master.Status==4}"></el-input>
                                    </td>
                                    <td>{{$t('getapi[6964]')}}</td>
                                    <td>
                                        <el-date-picker v-model="dataDetail.Master.PayTaxes_Date" type="date" size="mini"
                                                        style="width:100%"></el-date-picker>
                                    </td>
                                    <td>{{$t('getapi[6965]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Import_Tariff" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[6966]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Import_VAT" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                    <td>{{$t('getapi[6969]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Tracking_NO" type="text" size="mini"></el-input>
                                    </td>
                                    <td>{{$t('getapi[6934]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Unusual_Cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="dataDetail.Master.UCStatus != 0 && dataDetail.Master.UCStatus != 3" :class="{'readO':dataDetail.Master.UCStatus != 0 && dataDetail.Master.UCStatus != 3}"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[6948]')}}</td>
                                    <td>
                                        <el-select filterable v-model="dataDetail.Master.Unusual_Cost_Currency" size="mini">
                                            <el-option v-for="(item, index) in Currency" :label="item.currency_code"
                                                       :value="item.currency_code" :key="index"></el-option>
                                        </el-select>
                                    </td>
                                    <td>{{$t('getapi[6947]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Unusual_Remark" type="text" size="mini"></el-input>
                                    </td>
                                    <td>{{$t('getapi[6986]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.DCustoms_No" type="text" size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[6987]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Traffic_Cost_Time" type="text" size="mini"></el-input>
                                    </td>
                                    <td>{{$t('getapi[6988]')}}</td>
                                    <td>
                                        <a v-if="dataDetail.Master.Traffic_Cost_Url != null && dataDetail.Master.Traffic_Cost_Url != ''" @click="open(dataDetail.Master.Traffic_Cost_Url)" style="text-decoration:underline;color:blue">{{$t('getapi[6989]')}}</a>
                                        <el-button v-if="dataDetail.Master.Traffic_Cost_Url != null  && dataDetail.Master.Traffic_Cost_Url != ''" icon="el-icon-delete" type="text" size="small" @click="dataDetail.Master.Traffic_Cost_Url = '';dataDetail.Master.Traffic_Cost_Time = ''"></el-button>
                                    </td>
                                    <td>{{$t('getapi[6970]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Unusual_Cost_Time" type="text" size="mini"></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{$t('getapi[6971]')}}</td>
                                    <td>
                                        <a v-if="dataDetail.Master.Unusual_Cost_Url != null  && dataDetail.Master.Unusual_Cost_Url != ''" @click="open(dataDetail.Master.Unusual_Cost_Url)" style="text-decoration:underline;color:blue">{{$t('getapi[6990]')}}</a>
                                        <el-button v-if="dataDetail.Master.Unusual_Cost_Url != null  && dataDetail.Master.Unusual_Cost_Url != ''" icon="el-icon-delete" type="text" size="small" @click="dataDetail.Master.Unusual_Cost_Url = '';dataDetail.Master.Unusual_Cost_Time = ''"></el-button>
                                    </td>
                                    <td>{{$t('getapi[6933]')}}</td>
                                    <td>
                                        <el-input v-model="dataDetail.Master.Actual_Cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                                    </td>
                                </tr>
                            </table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[6991]')">
                            <div id="xdetilpane-0">
                            <vxe-table :data="dataDetail.Log_Order_LineList" :height="400"
                                       resizable
                                       show-overflow="tooltip"
                                       size="mini" border
                                       :auto-resize="true"
                                       show-summary
                                       header-row-class-name="headerclass">
                                <vxe-table-column show-footer-overflow field="Relation_PO_Code" :title="$t('getapi[1710]')" width="100"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="Row_Number" :title="$t('getapi[1425]')" width="60"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="Part_Code" :title="$t('getapi[226]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="Part_Name" :title="$t('getapi[116]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="Part_Version" :title="$t('getapi[149]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="line_tax_Amount" :title="$t('getapi[6992]')" width="110"></vxe-table-column>
                                <vxe-table-column field="line_net_unitprice" :title="$t('getapi[1303]')" width="100">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.line_net_unitprice" @change="changeValue(scope, 1)"></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="line_total_unitprice" :title="$t('getapi[3958]')" width="80">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.line_total_unitprice" @change="changeValue(scope, 2)"></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="line_total_amount" :title="$t('getapi[3959]')" width="80">
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="line_net_amount" :title="$t('getapi[1599]')" width="100">
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="PO_Qty" :title="$t('getapi[1628]')" width="60"></vxe-table-column>
                                <vxe-table-column field="Actual_Qty" :title="$t('getapi[1968]')" width="70">
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.Actual_Qty" @change="changeValue(scope, 3)"></el-input>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column show-footer-overflow field="model" :title="$t('getapi[124]')" width="60"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="Specification" :title="$t('getapi[125]')" width="60"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="pur_MeasureUnit" :title="$t('getapi[1166]')" width="110"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="line_status" :title="$t('getapi[552]')" width="60"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="plan_date" :title="$t('getapi[1612]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="shut_date" :title="$t('getapi[6993]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="shut_Person" :title="$t('getapi[2356]')" width="70"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="shut_reason" :title="$t('getapi[4211]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="cancel_reason" :title="$t('getapi[4474]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="cancel_person" :title="$t('getapi[6994]')" width="70"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="cancel_date" :title="$t('getapi[6995]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="relation_Requisition_line_id" :title="$t('getapi[1630]')" width="130"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="First_Vender_Flag" :title="$t('getapi[1615]')" width="110"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="create_person" :title="$t('getapi[3099]')" width="70"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="create_Time" :title="$t('getapi[135]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="Modify_person" :title="$t('getapi[733]')" width="70"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="Modify_Time" :title="$t('getapi[1210]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="remark" :title="$t('getapi[143]')" width="60"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="line_tax_Amount" :title="$t('getapi[3704]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="line_net_Amount_base" :title="$t('getapi[6996]')" width="130"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="line_total_Amount_base" :title="$t('getapi[6997]')" width="120"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="On_qty" :title="$t('getapi[1620]')" width="70"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="标记" :title="$t('getapi[6998]')" width="60"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="Check_Flag" :title="$t('getapi[6999]')" width="70"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="Exchange_Rate" :title="$t('getapi[7000]')" width="100"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="origin_Plan_Date" :title="$t('getapi[1601]')" width="80"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="Consumption_Date" :title="$t('getapi[1512]')" width="110"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="mro_order_no" :title="$t('getapi[7001]')" width="70"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="application_department" :title="$t('getapi[1833]')" width="60"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="application_person" :title="$t('getapi[7002]')" width="60"></vxe-table-column>
                                <vxe-table-column show-footer-overflow field="fa_flag" title="FA" width="60"></vxe-table-column>
                            </vxe-table>
                            </div>
                            <div>
                                <table>
                                    <tr>
                                        <td style="width:80px">{{$t('getapi[7003]')}}</td>
                                        <td style="width:120px">
                                            <el-input v-model="total_net_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                                      :readonly="true" class="readO"></el-input>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </el-tab-pane>
                    </el-tabs>

                </div>
              <!--  <el-tabs :tab-position="'top'" type="">
                    <el-tab-pane label="审核" name="0">
                        <el-table :data="dataDetail.DTAuditInfo" :height="tableHeight - 400" size="mini" border
                                  style="width: 100%;" header-row-class-name="headerclass">
                            &lt;!&ndash;<el-table-column show-overflow-tooltip prop="Sort" label="审核人顺序"></el-table-column>&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Audit_Person" label="审核人"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="userID" label="审核人ID"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Status" label="审核状态">
                                <template slot-scope="scope">
                                    {{expAuditStatus(scope.row.Audit_Status)}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Date" label="审核日期"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Msg" label="驳回意见"></el-table-column>
                            <el-table-column show-overflow-tooltip fixed="right" label="操作" width="80">
                                <template slot-scope="scope">
                                    <el-button style="padding: 0px"  v-if="dataDetail.Master.Status==1&&(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2) &&(user == scope.row.Audit_Person || scope.row.superior_flag==1) && scope.row.Exclusively_ID == currentAuditId" @click.native.prevent="Audit(scope,1)" type="text" size="small">审核</el-button>
                                    <el-button style="padding: 0px"  v-if="dataDetail.Master.Status==1&&(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2) &&(user == scope.row.Audit_Person || scope.row.superior_flag==1) && scope.row.Exclusively_ID == currentAuditId" @click.native.prevent="Audit(scope,2)" type="text" size="small">驳回</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="空运申请" name="1" v-if="false">
                        <table>
                            <tr>
                                <td style="width:60px">空运申请单编号</td>
                                <td style="width:150px;">
                                    <el-input v-model="dataDetail.Log_Airlift.Airlift_No" type="text" size="mini"></el-input>
                                </td>
                                <td style="width:60px">运输方式</td>
                                <td style="width:150px;">
                                    <el-input v-model="dataDetail.Log_Airlift.Airlift_Type" type="text" size="mini"></el-input>
                                </td>
                                <td style="width:60px">采购员</td>
                                <td style="width:150px;">
                                    <el-input v-model="dataDetail.Log_Airlift.Create_Person" type="text" size="mini"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>采购时间</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Log_Airlift.Create_Time" type="datetime" size="mini"
                                                    style="width:100%"></el-date-picker>
                                </td>
                                <td>状态</td>
                                <td>
                                    <el-input v-model="dataDetail.Log_Airlift.Status" type="text" size="mini"></el-input>
                                </td>
                                <td>备注</td>
                                <td>
                                    <el-input v-model="dataDetail.Log_Airlift.Remark" type="text" size="mini"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>原因</td>
                                <td>
                                    <el-input v-model="dataDetail.Log_Airlift.reason" type="text" size="mini"></el-input>
                                </td>
                                <td>项目名称</td>
                                <td>
                                    <el-input v-model="dataDetail.Log_Airlift.Item_Name" type="text" size="mini"></el-input>
                                </td>
                                <td>项目代码</td>
                                <td>
                                    <el-input v-model="dataDetail.Log_Airlift.Item_Code" type="text" size="mini"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>客户名称</td>
                                <td>
                                    <el-input v-model="dataDetail.Log_Airlift.Cus_Nmae" type="text" size="mini"></el-input>
                                </td>
                                <td>目的地</td>
                                <td>
                                    <el-input v-model="dataDetail.Log_Airlift.Dest" type="text" size="mini"></el-input>
                                </td>
                                <td>货车吨位</td>
                                <td>
                                    <el-input v-model="dataDetail.Log_Airlift.Truck_Tonnage" type="text" size="mini"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>海运公斤</td>
                                <td>
                                    <el-input v-model="dataDetail.Log_Airlift.Shipkg" type="text" size="mini"></el-input>
                                </td>
                                <td>正常费用</td>
                                <td>
                                    <el-input v-model="dataDetail.Log_Airlift.Normal_Cost" type="number" autocomplete="off" title="" size="mini"></el-input>
                                </td>
                                <td>空运/高速费用</td>
                                <td>
                                    <el-input v-model="dataDetail.Log_Airlift.Airlift_Cost" type="number" autocomplete="off" title="" size="mini"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>差价</td>
                                <td>
                                    <el-input v-model="dataDetail.Log_Airlift.Diff_Cost" type="number" autocomplete="off" title="" size="mini"></el-input>
                                </td>
                            </tr>
                        </table>
                    </el-tab-pane>
                    <el-tab-pane label="询价" name="2">
                        <el-button size="mini" type="primary" @click="addline" :disabled="dataDetail.Master.Status != 0 || dataDetail.Master.IsEdit == 1">新增</el-button>
                        <el-button size="mini" type="primary" @click="delline" :disabled="dataDetail.Master.Status != 0 || dataDetail.Master.IsEdit == 1">删除</el-button>
                        <el-table :data="dataDetail.Log_Ship_SchemeList" :height="tableHeight - 305" size="mini" border
                                  style="width: 100%;"
                                  header-row-class-name="headerclass"
                                  :row-class-name="tableRowClassName"
                                  @selection-change="handleSelectionChange"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Scheme_No" label="询价方案号">
                                <template scope="scope">
                                    <el-input v-model="scope.row.Scheme_No" type="text" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Status" label="状态">
                                <template scope="scope">
                                    <el-select filterable v-model="scope.row.Status"  size="mini" @change="changeSelectStatus(scope)">
                                        <el-option label="未选中" :value="0"></el-option>
                                        <el-option label="选中" :value="1"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Remark" label="备注">
                                <template scope="scope">
                                    <el-input v-model="scope.row.Remark" type="text" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Export_import" label="进出口">
                                <template scope="scope">
                                    <el-input v-model="scope.row.Export_import" type="text" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Cabinet_Type" label="柜型">
                                <template scope="scope">
                                    <el-input v-model="scope.row.Cabinet_Type" type="text" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Traffic_Agent" label="运货代理">
                                <template scope="scope">
                                    <el-input v-model="scope.row.Traffic_Agent" type="text" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Traffic_Type" label="交通方式">
                                <template scope="scope">
                                    <el-select filterable v-model="scope.row.Traffic_Type" size="mini">
                                        <el-option v-for="item in TrafficTypeArray" :key="item.Code" :label="item.Name"
                                                   :value="item.Code" style="width:100%"></el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Traffic_Clause" label="运输条款">
                                <template scope="scope">
                                    <el-input v-model="scope.row.Traffic_Clause" type="text" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Currency" label="货币单位">
                                <template scope="scope">
                                    <el-input v-model="scope.row.Currency" type="text" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Quoted_Price" label="报价" align="right">
                                <template scope="scope">
                                    <el-input v-model="scope.row.Quoted_Price" type="number" autocomplete="off" title="" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="First_Forwarder" label="首选货代">
                                <template scope="scope">
                                    <el-input v-model="scope.row.First_Forwarder" type="text" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="ETD" label="ETD">
                                <template scope="scope">
                                    <el-input v-model="scope.row.ETD" type="text" size="mini"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="ETA" label="ETA">
                                <template scope="scope">
                                    <el-input v-model="scope.row.ETA" type="text" size="mini"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>-->
                <div style="margin-top: 10px">
                    <el-divider content-position="left">{{$t('getapi[7011]')}}</el-divider>
                </div>
                <div style="display: flex;">
                    <el-button size="mini" type="primary" @click="addline" :disabled="(dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3)|| dataDetail.Master.IsEdit == 1">{{$t('getapi[878]')}}</el-button>
                    <el-button size="mini" type="primary" @click="delline" :disabled="(dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3) || dataDetail.Master.IsEdit == 1">{{$t('getapi[40]')}}</el-button>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            action=""
                            :on-preview="handlePreview2"
                            :on-remove="handleRemove2"
                            :on-change="handleChange2"
                            :on-success="handleSuccess2"
                            :on-error="handleError2"
                            :http-request="uploadFile2"
                            :auto-upload="true"
                            :disabled="dataDetail.Master.Status != 0 || dataDetail.Master.IsEdit == 1 || selectData.length != 1 || selectData[0].Exclusively_ID == 0"
                            style="margin-left: 8px;"
                    >
                        <el-button size="mini" type="primary" :disabled="selectData.length != 1 || dataDetail.Master.IsEdit == 1 || selectData.length != 1 || selectData[0].Exclusively_ID == 0">{{$t('getapi[7012]')}}</el-button>
                    </el-upload>
                </div>
                <el-table
                        id="xdetilpane-1"
                        :data="dataDetail.Log_Ship_SchemeList" :height="120" size="mini" border
                          style="width: 100%;"
                          header-row-class-name="headerclass"
                          :row-class-name="tableRowClassName"
                          @selection-change="handleSelectionChange"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="Scheme_No" :label="$t('getapi[7013]')">
                        <template scope="scope">
                            <el-input v-model="scope.row.Scheme_No" type="text" size="mini" class="mcolor"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Status" :label="$t('getapi[552]')">
                        <template scope="scope">
                            <el-select filterable v-model="scope.row.Status"  size="mini" @change="changeSelectStatus(scope)">
                                <el-option :label="$t('getapi[7014]')" :value="0"></el-option>
                                <el-option :label="$t('getapi[7015]')" :value="1"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Remark" :label="$t('getapi[143]')">
                        <template scope="scope">
                            <el-input
                                    v-model="scope.row.Remark"
                                    type="text"
                                    size="mini"
                                    class="mcolor"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectRemark(scope)"></i>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Export_import" :label="$t('getapi[7016]')">
                        <template scope="scope">
                            <el-input
                                    v-model="scope.row.Export_import"
                                    type="text"
                                    size="mini"
                                    class="mcolor"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectExport_import(scope)"></i>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Cabinet_Type" :label="$t('getapi[7007]')">
                        <template scope="scope">
                            <el-input
                                    v-model="scope.row.Cabinet_Type"
                                    type="text"
                                    size="mini"
                                    class="mcolor"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectCabinet_Type(scope)"></i>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Traffic_Agent" :label="$t('getapi[7017]')">
                        <template scope="scope">
                            <el-input
                                    v-model="scope.row.Traffic_Agent"
                                    type="text"
                                    size="mini"
                                    class="mcolor"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectTraffic_Agent(scope)"></i>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Traffic_Type" :label="$t('getapi[6954]')">
                        <template scope="scope">
                            <el-select filterable v-model="scope.row.Traffic_Type" size="mini">
                                <el-option v-for="item in TrafficTypeArray" :key="item.Code" :label="item.Name"
                                           :value="item.Code" style="width:100%"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Traffic_Clause" :label="$t('getapi[7018]')">
                        <template scope="scope">
                            <el-input
                                    v-model="scope.row.Traffic_Clause"
                                    type="text"
                                    size="mini"
                                    class="mcolor"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectTraffic_Clause(scope)"></i>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Currency" :label="$t('getapi[6379]')">
                        <template scope="scope">
                            <!--<el-input v-model="scope.row.Currency" type="text" size="mini"></el-input>-->
                            <el-select filterable v-model="scope.row.Currency" size="mini">
                                <el-option v-for="(item, index) in Currency" :label="item.currency_code"
                                           :value="item.currency_code" :key="index"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Quoted_Price" :label="$t('getapi[7019]')" align="right">
                        <template scope="scope">
                            <el-input v-model="scope.row.Quoted_Price" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" class="mcolor"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="First_Forwarder" :label="$t('getapi[7020]')">
                        <template scope="scope">
                            <el-input
                                    v-model="scope.row.First_Forwarder"
                                    type="text"
                                    size="mini"
                                    class="mcolor"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectFirst_Forwarder(scope)"></i>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ETD" label="ETD">
                        <template scope="scope">
                            <el-input v-model="scope.row.ETD" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ETA" label="ETA">
                        <template scope="scope">
                            <el-input v-model="scope.row.ETA" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="File_Url" :label="$t('getapi[7021]')">
                        <template scope="scope">
                            <a v-if="scope.row.File_Url != '' && scope.row.File_Url != null" @click="open(scope.row.File_Url)" style="text-decoration:underline;color:blue">{{$t('getapi[6503]')}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="File_Time" :label="$t('getapi[7022]')">
                    </el-table-column>
                </el-table>
                <div style="margin-top: 10px">
                    <el-divider content-position="left">{{$t('getapi[6934]')}}</el-divider>
                </div>
                <div style="display: flex;">
                    <el-button size="mini" type="primary" @click="addunline" :disabled="dataDetail.Master.UCStatus == 1">{{$t('getapi[878]')}}</el-button>
                    <el-button size="mini" type="primary" @click="delunline" :disabled="dataDetail.Master.UCStatus == 1">{{$t('getapi[40]')}}</el-button>
                    <el-button size="mini" type="primary" @click="saveun">{{$t('getapi[937]')}}</el-button>
                </div>
                <el-table
                        id="xdetilpane-4"
                        :data="dataDetail.Log_Ship_UnusualCostList" :height="120" size="mini" border
                        style="width: 100%;"
                        header-row-class-name="headerclass"
                        :row-class-name="tableRowClassNameun"
                        @selection-change="handleSelectionChangeun"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="Unusual_Remark" :label="$t('getapi[143]')">
                        <template scope="scope">
                            <el-input v-model="scope.row.Unusual_Remark" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Status" :label="$t('getapi[552]')">
                        <template scope="scope">
                            <el-input :value="expunStatus(scope.row.Status)" type="text" size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[410]')">
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Time" :label="$t('getapi[4044]')">
                    </el-table-column>
                    <el-table-column prop="Unusual_Cost" :label="$t('getapi[6934]')">
                        <template scope="scope">
                            <el-input v-model="scope.row.Unusual_Cost" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Unusual_Cost_Currency" :label="$t('getapi[6379]')">
                        <template scope="scope">
                            <el-select filterable v-model="scope.row.Unusual_Cost_Currency" size="mini">
                                <el-option v-for="(item, index) in Currency" :label="item.currency_code"
                                           :value="item.currency_code" :key="index"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Vender_Code" :label="$t('getapi[1323]')">
                        <template scope="scope">
                            <el-input v-model="scope.row.Vender_Code"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Unusual_Cost_Url" :label="$t('getapi[7021]')">
                        <template scope="scope">
                            <a v-if="scope.row.Unusual_Cost_Url != '' && scope.row.Unusual_Cost_Url != null" @click="open(scope.row.Unusual_Cost_Url)" style="text-decoration:underline;color:blue">{{$t('getapi[6503]')}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Unusual_Cost_Time" :label="$t('getapi[7022]')">
                    </el-table-column>
                    <el-table-column align="center" :label="$t('getapi[6974]')" width="120">
                        <template slot-scope="scope" v-if="!$limits.fnIsEmpty(scope.row.Exclusively_ID)">
                            <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    action=""
                                    :on-preview="handlePreview5"
                                    :on-remove="handleRemove5"
                                    :on-change="handleChange5"
                                    :on-success="handleSuccess5"
                                    :on-error="handleError5"
                                    :http-request="uploadFile5"
                                    :auto-upload="true"
                                    style="margin-left: 8px;"
                            >
                                <el-button type="primary" size="mini" @click="bindId(scope.row.Exclusively_ID)">{{$t('getapi[6974]')}}
                                </el-button>
                            </el-upload>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top: 10px">
                    <el-divider content-position="left">{{$t('getapi[941]')}}</el-divider>
                </div>
                <div style="display: flex;">
                    <el-button size="mini" type="primary" @click="addauditer" :disabled="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3">{{$t('getapi[878]')}}</el-button>
                    <el-button size="mini" type="primary" @click="delauditer" :disabled="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3">{{$t('getapi[40]')}}</el-button>
                    <el-button size="mini" type="primary" @click="saveauditer" :disabled="dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3">{{$t('getapi[937]')}}</el-button>
                </div>
                <el-table
                        id="xdetilpane-2"
                        :data="dataDetail.DTAuditInfo" :height="130" size="mini" border
                          style="width: 100%;" header-row-class-name="headerclass"
                          :row-class-name="tableRowClassName1"
                        @selection-change="handleSelectionChangeAuditer"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Sort" :label="$t('getapi[13120]')">
                        <template scope="scope">
                            <el-input v-model="scope.row.Sort" type="text" size="mini" v-if="(dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3) && dataDetail.Master.IsEdit != 1"></el-input>
                            <span v-if="(dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3)|| dataDetail.Master.IsEdit == 1">{{scope.row.Sort}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[4043]')">
                        <template scope="scope">
                        <el-input
                                v-model="scope.row.Audit_Person"
                                type="text"
                                size="mini"
                                class="mcolor"
                                v-if="(dataDetail.Master.Status == 0 || dataDetail.Master.Status == 3) && dataDetail.Master.IsEdit != 1"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectAuditer(scope)"></i>
                        </el-input>
                            <span v-if="(dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3)|| dataDetail.Master.IsEdit == 1">{{scope.row.Audit_Person}}</span>
                        </template>
                    </el-table-column>
                    <!--<el-table-column show-overflow-tooltip prop="userID" label="审核人ID"></el-table-column>-->
                    <el-table-column show-overflow-tooltip prop="Audit_Status" :label="$t('getapi[6470]')">
                        <template slot-scope="scope">
                            {{expAuditStatus(scope.row.Audit_Status)}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[742]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Msg" :label="$t('getapi[6471]')"></el-table-column>
                    <el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
                        <template slot-scope="scope">
                            <el-button style="padding: 0px"  v-if="dataDetail.Master.Status==1&&(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2) &&(user == scope.row.Audit_Person || scope.row.superior_flag==1) && scope.row.Exclusively_ID == currentAuditId" @click.native.prevent="Audit(scope,1)" type="text" size="small">{{$t('getapi[941]')}}</el-button>
                            <el-button style="padding: 0px"  v-if="dataDetail.Master.Status==1&&(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2) &&(user == scope.row.Audit_Person || scope.row.superior_flag==1) && scope.row.Exclusively_ID == currentAuditId" @click.native.prevent="Audit(scope,2)" type="text" size="small">{{$t('getapi[6228]')}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top: 10px">
                    <el-divider content-position="left">{{$t('getapi[6951]')}}</el-divider>
                </div>
                <el-table :data="dataDetail.DTAuditInfo" :height="120" size="mini" border
                          style="width: 100%;" header-row-class-name="headerclass"
                          :row-class-name="tableRowClassName2">
                    <!--<el-table-column show-overflow-tooltip prop="Sort" label="审核人顺序"></el-table-column>-->
                    <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[550]')"></el-table-column>
                    <!--<el-table-column show-overflow-tooltip prop="userID" label="审核人ID"></el-table-column>-->
                    <el-table-column prop="Audit_Status" :label="$t('getapi[6470]')">
                        <template slot-scope="scope">
                            {{expAuditStatus(scope.row.Audit_Status)}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[742]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_Msg" :label="$t('getapi[6471]')"></el-table-column>
                    <el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
                        <template slot-scope="scope">
                            <el-button style="padding:0px"  v-if="(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2)&& (user == scope.row.Audit_Person || scope.row.superior_flag==1)" @click.native.prevent="Audit(scope,1)" type="text" size="small">审核</el-button>
                            <el-button style="padding:0px"  v-if="(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2)&& (user == scope.row.Audit_Person || scope.row.superior_flag==1)" @click.native.prevent="Audit(scope,2)" type="text" size="small">驳回</el-button>
                        </template>
                    </el-table-column>
                </el-table>

            </li>
        </ul>
        <el-row v-if="SelectIndexs == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="LogShipViewInfo" ref="ser" @getser="serclick"></serce>
        <el-dialog v-dialogDrag
                   :title="$t('getapi[6472]')"
                   :visible.sync="CloseDialogVisible"
                   width="30%"
        >
            <el-input
                    type="textarea"
                    :rows="5"
                    v-model="resontxt">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmAudit(selectrow,2)">{{$t('getapi[1146]')}}</el-button>
            </span>
        </el-dialog>

        <selector :isVisible="false" :selectType="0" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetEngItemDataList'" @callback="getItemCode" ref="itemcode"></selector>
        <selector :isVisible="false" :selectType="0" :isBatch=false :isSplitPage=true :postUrl="'/Pur/Invoice/GetPurInvoiceSupplyList'" @callback="getVenderCode" ref="vendercode"></selector>
        <selector :isVisible="false" :selectType="1" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetDeptDataList'" @callback="getDutyDeptNum" ref="dutydeptnum"></selector>
        <!--提货地址-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetAdressPopuDataList'" @callback="getLieferAdress" ref="lieferadress"></selector>
        <!--单位-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetAdressPopuDataList'" @callback="getUnit" ref="unit"></selector>
        <!--询价-备注-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetAdressPopuDataList'" @callback="getRemark" ref="remark"></selector>
        <!--询价-进出口-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetAdressPopuDataList'" @callback="getExport_import" ref="export_import"></selector>
        <!--询价-柜型-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetAdressPopuDataList'" @callback="getCabinet_Type" ref="cabinet_type"></selector>
        <!--询价-货运代理-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetAdressPopuDataList'" @callback="getTraffic_Agent" ref="traffic_agent"></selector>
        <!--询价-运输条款-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetAdressPopuDataList'" @callback="getTraffic_Clause" ref="traffic_clause"></selector>
        <!--询价-首选货代-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetAdressPopuDataList'" @callback="getFirst_Forwarder" ref="first_forwarder"></selector>
        <!--审核人-->
        <selector :isVisible="false" :selectType="1" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getAuditer" ref="auditer"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';

    export default {
        name: 'logcarshipview',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                personData: [],
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('logcarshipview'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight1,
                code: '',
                dataDetail: {
                    Master: {},
                    DTAuditInfo: [],
                    Log_Airlift: {},
                    Log_Ship_SchemeList: [],
                    Log_Ship_UnusualCostList:[],
                },
                TrafficTypeArray: [
                    {
                        Code: '海运',
                        Name: this.$t('getapi[8632]')//'海运'
                    },
                    {
                        Code: '空运',
                        Name: this.$t('getapi[8633]')//'空运'
                    },
                    {
                        Code: '陆运',
                        Name: this.$t('getapi[8634]')//'陆运'
                    },
                    {
                        Code: '快递',
                        Name: this.$t('getapi[8635]')//'快递'
                    },
                ],
                TrafficModeArray: [
                    {
                        Code: '大件',
                        Name: this.$t('getapi[8636]')//'大件'
                    },
                    {
                        Code: '小件',
                        Name: this.$t('getapi[8637]')//'小件'
                    },
                ],
                CloseDialogVisible: false,
                selectrow: {},
                resontxt: '',
                uploadurl: '',
                fileList: [],
                file: null,
                fileList1: [],
                file1: null,
                fileList3: [],
                file3: null,
                fileList4: [],
                file4: null,
                fileList5: [],
                file5: null,
                Line_ID: '',
                oldrow: '',
                iscontinuedblclick: true,
                selectData: [],
                selectunData:[],
                currentAuditId: 0, // 当前可审核下标
                btn: {
                    unusualsubmit: false,
                    close: true,
                    submit: false,
                },
                Currency: [], //货币代码
                total_net_amount: '', //不含税总金额
                timeId: null,
                selectDataView: [], //
                rowindexScheme:'',
                scrollTop:0,
                scrollTop1:0,
                rowindexAuditer:'',
                selectDataAuditer:[],
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndexs)
                })
            },
            personData: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndexs)
                })
            },
            'dataDetail.Log_Order_LineList': function(){
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initFormRight(0)
                })
            },
            'dataDetail.Log_Ship_SchemeList': function(){
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initFormRight(1)
                })
            },
            'dataDetail.DTAuditInfo': function(){
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initFormRight(2)
                    that.$processdata.initFormRight(3)
                })
            }
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('logcarshipview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$http.urlpost('CurrencySource', {}, function (res) {
                if (res.Success == 1) {
                    that.Currency = res.DataContent;
                }
            });
            that.$limits.dragControllerDiv();
            that.confirmAdd();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6581]"),this.$t("getapi[6577]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (!that.$limits.fnIsEmpty(that.dataDetail.Master.Doc_No)) {
                    if (that.dataDetail.Master.Status == 0 || that.dataDetail.Master.Status == 4 ||  that.dataDetail.Master.Status == 5) {
                        that.$refs.SetBtn.SetButtonEnable('create,search,save,del,refresh');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh');
                    }
                } else {
                    that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh');
                }
                that.btnauthority()
            },
            btnauthority() {
                let that = this;
                that.btn.submit = false
                that.btn.unusualsubmit = false
                that.btn.close = true
                if (!that.$limits.fnIsEmpty(that.dataDetail.Master.Doc_No)) {
                    if(that.dataDetail.Master.Status == 0 || that.dataDetail.Master.Status == 3){
                        that.btn.submit = true
                    }
                    if(that.dataDetail.Master.UCStatus == 0 || that.dataDetail.Master.UCStatus == 3 ){
                        that.btn.unusualsubmit = true
                    }
                    if(that.dataDetail.Master.Status == 4){
                        that.btn.close = false
                        that.btn.submit = false
                    }
                    that.btn.unusualsubmit = that.dataDetail.Log_Ship_UnusualCostList.some(val => {
                        return (val.Status == 0 || val.Status == 3)
                    });
                } else {
                    that.btn.submit = false
                    that.btn.unusualsubmit = false
                    that.btn.close = false
                }
                that.currentAuditId = 0
                let arrDTAuditInfo = []
                for(let i = 0;i<that.dataDetail.DTAuditInfo.length;i++){
                    if(that.dataDetail.DTAuditInfo[i].Unusual_Flag == false){
                        arrDTAuditInfo.push(that.dataDetail.DTAuditInfo[i])
                    }
                }
                if(arrDTAuditInfo.length > 0){
                    let arr = arrDTAuditInfo.filter(row => row.Audit_Status == 0 || row.Audit_Status == 2)
                    let compare = function(obj1,obj2){
                        let val1 = obj1.Sort;
                        let val2 = obj2.Sort;
                        if(val1 < val2){
                            return -1;
                        }else if(val1 > val2){
                            return 1;
                        }else{
                            return 0;
                        }
                    }
                    let sortArr = arr.sort(compare);
                    if(sortArr.length > 0){
                        that.currentAuditId = sortArr[0].Exclusively_ID
                    }
                }
            },
            selectInfo(tab, event){
                let that = this
                that.SelectIndexs = tab.name
                if(that.SelectIndexs == 0){
                    that.getView()
                } else if(that.SelectIndexs == 1){
                    that.getAuditPerson()
                }
                that.$nextTick(function(){
                    that.$processdata.initForm(that.SelectIndexs)
                });
            },
            tableRowClassName({ row, rowIndex }) {
                row.index = rowIndex;
                if (row.Status == 1) {
                    return 'blue';
                }
            },
            tableRowClassName1({row, rowIndex}){
                if(row.Unusual_Flag == 1){
                    return 'hidden'
                }
            },
            tableRowClassName2({row, rowIndex}){
                if(row.Unusual_Flag != 1){
                    return 'hidden'
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('logcarshipview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
             // 查询
             search() {
                 let that = this;
                 that.isVisible = true;
                 that.$refs.ser.clearInput(that.isVisible, 'LogShipViewInfo');
             },
             //获取查询条件
             serclick(val) {
                 this.queryData = val;
                 this.confirmGetView();
             },
             // 确认获取数据
             confirmGetView() {
                 let that = this;
                 that.pageIndex = 1
                 that.isVisible = false;
                 that.getView();
             },
            getAuditPerson(){
                let that = this
                let parm = {
                    AuditPerson: that.user,
                    SelectIndex: 0
                }
                that.$http.urlpost('/LogShip/LogShipListByAuditPerson', parm , function (res) {
                    if (res.Success == 1) {
                        that.personData = res.DataContent
                    }
                });
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: 0,
                    Param: datac
                };
                that.$http.urlpost('/LogShip/GetLogShipView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.code == row.Exclusively_ID){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.Log_Ship_SchemeList.length;i++){
                        delete datacopy.Log_Ship_SchemeList[i]['index']
                    }
                    for(let i = 0;i<datacopy.Log_Order_LineList.length;i++){
                        delete datacopy.Log_Order_LineList[i]['_XID']
                    }
                    for(let i = 0;i<datacopy.Log_Ship_UnusualCostList.length;i++){
                        delete datacopy.Log_Ship_UnusualCostList[i]['index']
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.addoredit = 2;
                                that.code = row.Exclusively_ID
                                that.getDetail(that.code);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if(that.SelectIndexs == 0){
                                    that.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if(that.SelectIndexs == 1){
                                    that.$refs.singleTable1.setCurrentRow(that.oldrow);
                                }
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.addoredit = 2;
                        that.code = row.Exclusively_ID
                        that.getDetail(that.code);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(code) {
                let that = this;
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/LogShip/LogShipInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.countAmount()
                    }
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Log_Ship_SchemeList.length;i++){
                    delete datacopy.Log_Ship_SchemeList[i]['index']
                }
                for(let i = 0;i<datacopy.Log_Order_LineList.length;i++){
                    delete datacopy.Log_Order_LineList[i]['_XID']
                }
                for(let i = 0;i<datacopy.Log_Ship_UnusualCostList.length;i++){
                    delete datacopy.Log_Ship_UnusualCostList[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                that.addoredit = 1;
                that.code = ''
                that.dataDetail = {
                    Master: {
                        Exclusively_ID:0,
                        Doc_No:'',
                        PurOrder_No:'',
                        SalOrder_No:'',
                        Status:0,
                        UCStatus:0,
                        Create_Person:'',
                        Create_Person_Dept:'',
                        Create_Time:'',
                        Modify_Person:'',
                        Modify_Time:'',
                        IO_Mode:'进口',
                        Traffic_Type:'海运',
                        Traffic_Mode:'大件',
                        Airlift_No:'',
                        Airlift_Url:'',
                        Airlift_Cost:0,
                        Scheme_No:'',
                        Notice_Date:'',
                        ToPort_Date:'',
                        Release_Date:'',
                        ToFactory_Date:'',
                        PayTaxes_Date:'',
                        Import_Tariff:'',
                        Import_VAT:'',
                        Traffic_Cost:0,
                        Abroad_Cost:0,
                        Vender_Name:'',
                        Vender_Code:'',
                        Item_Name:'',
                        Item_Code:'',
                        Quantity:'',
                        Weight:'',
                        Tracking_NO:'',
                        Remark:'',
                        Invoice_No:'',
                        IsEdit:1,
                        Audit_Person:'',
                        Expect_PickTime:'',
                        Require_ArrivalTime:'',
                        Unit:'',
                        Liefer_Adress:'',
                        Net_Weight:'',
                        Gross_Weight:'',
                        Volume:'',
                        Cabinet_Type:'',
                        Trade_Mode:'',
                        ETA:'',
                        ETD:'',
                        Unusual_Cost: 0,
                        Unusual_Remark: "",
                        Origin_Country: "",
                        DCustoms_No: "",
                        Track_Num: "",
                        Traffic_Cost_Time: '',
                        Traffic_Cost_Url:'',
                        Airlift_Reason: '',
                        Package_Size: '',
                        Pur_Contract_Url: '',
                        Pur_Contract_Time: '',
                        Duty_DeptNum:"",
                        Duty_Dept:'',
                        Unusual_Cost_Time: '',
                        Unusual_Cost_Url: '',
                        Unusual_Cost_Currency: '',
                        Goods_Value: null,
                        Goods_Currency: '',
                        Notice_Log: '',
                        Notice_Time: '',
                        Submit_Person: null,
                        Submit_Time: null,
                        Invoice_Flag: false,
                        LangType: 0,
                        Return_Flag: 0,
                        Actual_Cost: '',
                    },
                    DTAuditInfo: [],
                    Log_Airlift: {
                        Exclusively_ID:0,
                        Relation_IID:0,
                        Airlift_No:'',
                        Airlift_Type:'',
                        Create_Person:'',
                        Create_Time:'',
                        Modify_Person:'',
                        Modify_Time:'',
                        Status:0,
                        Remark:'',
                        reason:'',
                        Item_Name:'',
                        Item_Code:'',
                        Cus_Nmae:'',
                        Cus_Code:'',
                        Dest:'',
                        Truck_Tonnage:'',
                        Shipkg:'',
                        Normal_Cost:0,
                        Airlift_Cost:0,
                        Diff_Cost:0,
                        IsEdit:1,
                        Audit_Person:'',
                        Urgent_Flag:true,
                        Duty_Dept:'',
                        Duty_DeptNum:'',
                        Cus_Num:'',
                        Airlift_Reason:'',
                    },
                    Log_Ship_SchemeList: [],
                    Log_Ship_UnusualCostList:[],
                    Log_Order_LineList: [],
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Log_Ship_SchemeList.length;i++){
                    delete datacopy.Log_Ship_SchemeList[i]['index']
                }
                for(let i = 0;i<datacopy.Log_Order_LineList.length;i++){
                    delete datacopy.Log_Order_LineList[i]['_XID']
                }
                for(let i = 0;i<datacopy.Log_Ship_UnusualCostList.length;i++){
                    delete datacopy.Log_Ship_UnusualCostList[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 2){
                                that.getView();
                                that.getDetail(that.code)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if(that.addoredit == 2){
                        that.getView();
                        that.getDetail(that.code)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/LogShip/GetLogShipViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            expCostJustOrder(){
                let that = this
                let parm = that.dataDetail.Master
                that.$http.urlpost('/LogShip/RecCostJustOrderToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 导出进出口汇总
            expSum(){
                let that = this
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: 0,
                    Ids: '',
                    Param: datac,
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[11878]')
                };
                that.$http.urlpost('/LogShip/ImportSumToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 保存
            save() {
                let that = this;
                for(let i = 0;i<that.dataDetail.Log_Ship_SchemeList.length;i++){
                    if(that.dataDetail.Log_Ship_SchemeList[i].Quoted_Price == ''){
                        that.$message.warning(that.$t('getapi[8638]'))//'询价-报价不能为空'
                        return
                    }
                    if(that.dataDetail.Log_Ship_SchemeList[i].Scheme_No == ''){
                        that.$message.warning(that.$t('getapi[8639]'))//'询价-询价方案号不能为空'
                        return
                    }
                }
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                let parm = that.dataDetail;
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/LogShip/SaveLogShip', parm, function (res) {
                    if (res.Success == 1) {
                        that.getView()
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                });

            },
            expStatus(val){
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[8057]')//'审核中';
                } else if (val == 2) {
                    return that.$t('getapi[5160]')//'批准';
                } else if (val == 3) {
                    return that.$t('getapi[5161]')//'驳回';
                } else if(val == 4){
                    return that.$t('getapi[3557]')//'关闭'
                } else if(val == 5){
                    return that.$t('getapi[1902]')//'作废'
                } else {
                    return ''
                }
            },
            expunStatus(val){
                let that = this
                if(val == 0){
                    return that.$t('getapi[1422]')//'生成'
                } else if(val == 1){
                    return that.$t('getapi[6468]')//'提交'
                } else if(val == 2){
                    return that.$t('getapi[941]')//'审核'
                } else if(val == 3){
                    return that.$t('getapi[5161]')//'驳回'
                } else {
                    return ''
                }
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            ids: that.dataDetail.Master.Exclusively_ID
                        }
                        that.$http.urlpost('/LogShip/DelLogShipByID', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 1提交4关闭
            setStatus(val){
                let that = this;
                if(that.dataDetail.Master.PurOrder_No == ''){
                    that.$message.warning(that.$t('getapi[8640]'))//'采购订单号不能为空！'
                    return
                }
                if(that.dataDetail.Master.Expect_PickTime == ''){
                    that.$message.warning(that.$t('getapi[8641]'))//'要求提货时间不能为空！'
                    return
                }
                if(that.dataDetail.Master.Require_ArrivalTime == ''){
                    that.$message.warning(that.$t('getapi[8642]'))//'要求到货时间不能为空！'
                    return
                }
                if(that.dataDetail.Master.Vender_Code == ''){
                    that.$message.warning(that.$t('getapi[1252]'))//'供应商代码不能为空！'
                    return
                }
                if(that.dataDetail.Master.Quantity == ''){
                    that.$message.warning(that.$t('getapi[8643]'))//'件数不能为空！'
                    return
                }
                if(that.dataDetail.Master.Weight == ''){
                    that.$message.warning(that.$t('getapi[8644]'))//'重量不能为空！'
                    return
                }
                if(that.dataDetail.Master.Goods_Value == null){
                    that.$message.warning(that.$t('getapi[8645]'))//'货值不能为空！'
                    return
                }
                if(that.dataDetail.Master.Goods_Currency == ''){
                    that.$message.warning(that.$t('getapi[8646]'))//'货值币种不能为空！'
                    return
                }
                if(that.dataDetail.Master.Traffic_Cost == ''){
                    that.$message.warning(that.$t('getapi[8647]'))//'运费不能为空！'
                    return
                }
                if(that.dataDetail.Master.Traffic_Cost_Currency == ''){
                    that.$message.warning(that.$t('getapi[8648]'))//'运费币种不能为空！'
                    return
                }
                if(that.dataDetail.Master.Unit == ''){
                    that.$message.warning(that.$t('getapi[8649]'))//'单位不能为空！'
                    return
                }
                if(val == 4 && that.$limits.fnIsEmpty(that.dataDetail.Master.Actual_Cost)){
                    that.$message.warning(that.$t('getapi[11734]'))//'实际费用不能为空！'
                    return
                }
                let oldStatus = that.dataDetail.Master.Status.toString()
                that.dataDetail.Master.Status = val
                let parm = that.dataDetail.Master;
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/LogShip/LogShipSetStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.getDetail(that.code)
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    } else {
                        that.dataDetail.Master.Status = oldStatus
                    }
                });
            },
            // 异常费用提交
            unusualSetStatus(val){
                let that = this
                that.dataDetail.Master.UCStatus = val
                let parm = that.dataDetail.Master
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/LogShip/UnusualCostSetStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.getDetail(that.code)
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 审核 驳回
            Audit(scope,flag){
                let that =this;
                if(flag == 1){
                    this.$confirm(that.$t('getapi[8606]'), that.$t('getapi[194]'), {//'确认审核通过吗'
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.confirmAudit(scope.row,1)
                        })
                        .catch(() => {
                        });
                } else if(flag==2){
                    that.CloseDialogVisible = true;
                    that.selectrow = scope.row;
                    that.resontxt = '';
                }
            },
            confirmAudit(row,type){
                let that = this
                row.Audit_Date = that.$limits.getDateTime()
                if(type == 1){
                    row.Audit_Msg = ''
                } else {
                    row.Audit_Msg = that.resontxt
                }
                row.Audit_Status = type
                let parm = row
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/LogShip/LogShipInfoSetStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.getView();
                        that.getDetail(that.code);
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.CloseDialogVisible = false
                    }  else {
                        that.getDetail(that.code);
                    }
                });
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            handleChange(file, fileList) {
                let that = this;
                that.file = file.raw
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    console.log('导入成功')
                }
                that.fileList=[];
                that.loading = false;
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
                that.loading = false;
            },
            uploadFile(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file);
                formData.append('Exclusively_ID', that.dataDetail.Master.Exclusively_ID)
                that.$http.urlpost('/LogShip/UploadFilesResult', formData, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                        that.authority();
                    }
                });
            },
            // 运费附件上传（多对一）
            handleRemove4(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview4(file) {
                console.log("handlePreview"+file);
            },
            handleChange4(file, fileList) {
                let that = this;
                that.file4 = file.raw
            },
            handleSuccess4(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    console.log('导入成功')
                }
                that.fileList4=[];
            },
            handleError4(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            uploadFile4(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file4);
                let id = ''
                for(let i = 0;i<that.selectDataView.length;i++){
                    id = id + that.selectDataView[i].Exclusively_ID + ','
                }
                id = id.substring(0,id.length-1)
                formData.append('Exclusively_ID', id)
                that.$http.urlpost('/LogShip/UploadFilesResults', formData, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                        that.authority();
                    }
                });
            },
            //采购合同
            handleRemove1(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview1(file) {
                console.log("handlePreview"+file);
            },
            handleChange1(file, fileList) {
                let that = this;
                that.file1 = file.raw
            },
            handleSuccess1(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    console.log('导入成功')
                }
                that.fileList1=[];
                that.loading = false;
            },
            handleError1(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
                that.loading = false;
            },
            uploadFile1(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file1);
                formData.append('Exclusively_ID', that.dataDetail.Master.Exclusively_ID)
                that.$http.urlpost('/LogShip/UploadFilesPurContract', formData, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                        that.authority();
                    }
                });
            },
            // 异常费用附件上传
            handleRemove3(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview3(file) {
                console.log("handlePreview"+file);
            },
            handleChange3(file, fileList) {
                let that = this;
                that.file3 = file.raw
            },
            handleSuccess3(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    console.log('导入成功')
                }
                that.fileList3=[];
            },
            handleError3(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            uploadFile3(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file3);
                formData.append('Exclusively_ID', that.dataDetail.Master.Exclusively_ID)
                that.$http.urlpost('/LogShip/UploadFilesUnusual_Cost', formData, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                        that.authority();
                    }
                });
            },
            // 异常费用附件上传
            handleRemove5(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview5(file) {
                console.log("handlePreview"+file);
            },
            handleChange5(file, fileList) {
                let that = this;
                that.file5 = file.raw
            },
            handleSuccess5(res, file, fileList) {
                let that = this;
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    console.log('导入成功')
                }
                that.fileList5=[];
            },
            handleError5(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            bindId(id){
                let that = this
                that.Line_ID = id
            },
            uploadFile5(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file5);
                formData.append('Line_ID', that.Line_ID)
                that.$http.urlpost('/LogShip/UploadFilesUnusual_Cost', formData, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                        that.authority();
                    }
                });
            },
            //询价方案上传
            handleRemove2(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview2(file) {
                console.log("handlePreview"+file);
            },
            handleChange2(file, fileList) {
                let that = this;
                that.file2 = file.raw
            },
            handleSuccess2(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    console.log('导入成功')
                }
                that.fileList2=[];
            },
            handleError2(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            uploadFile2(){
                let that = this;
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file2);
                formData.append('Exclusively_ID', that.selectData[0].Exclusively_ID)
                that.$http.urlpost('/LogShip/UploadFilesScheme', formData, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                        that.authority();
                    }
                });
            },
            // 新增询价方案
            addline(){
              let that = this
              that.dataDetail.Log_Ship_SchemeList = [...that.dataDetail.Log_Ship_SchemeList,{
                  Exclusively_ID: 0,
                  Relation_IID: that.dataDetail.Master.Exclusively_ID,
                  Scheme_No: '',
                  Create_Person: '',
                  Create_Time: '',
                  Status: 0,
                  Remark: '',
                  Export_import: that.dataDetail.Master.IO_Mode,
                  Cabinet_Type: '',
                  Traffic_Agent: '',
                  Traffic_Type: that.dataDetail.Master.Traffic_Type,
                  Traffic_Clause: '',
                  Currency: '',
                  Quoted_Price: '',
                  First_Forwarder: '',
                  ETD: '',
                  ETA: ''
              }]
            },
            // 删除询价表明细
            delline(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let ids = ''
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.dataDetail.Log_Ship_SchemeList.splice(that.selectData[i].index, 1);
                            if(that.selectData[i].Exclusively_ID!=0){
                                ids = ids + that.selectData[i].Exclusively_ID + ',';
                            }
                        }
                        if(ids != ''){
                            ids = ids.substring(0, ids.length -1)
                            let parm = {
                                ids: ids
                            }
                            that.$http.urlpost('/LogShip/DelLogShipSchemeByID', parm , function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 修改运输方式
            changeTrafficType(val){
                let that = this
                if(val == '海运'){
                    that.dataDetail.Master.Airlift_No = ''
                    that.dataDetail.Master.Airlift_Cost = ''
                }
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
            },
            // 批量选择(异常费用)
            handleSelectionChangeun(val) {
                let that = this;
                that.selectunData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectunData.push(val[i]);
                }
            },
            handleSelectionChangeAuditer(val){
                let that = this
                that.selectDataAuditer = val
            },
            selectItemCode() {
                let that = this;
                that.$refs.itemcode.clearInput(true);
            },
            getItemCode(val) {
                let that = this;
                console.log(val)
                that.dataDetail.Master.Item_Code = val.item_code;
                that.dataDetail.Master.Item_Name = val.item_name;
            },
            selectVenderCode() {
                let that = this;
                that.$refs.vendercode.clearInput(true);
            },
            getVenderCode(val) {
                let that = this;
                console.log(val)
                that.dataDetail.Master.Vender_Code = val.vender_code;
                that.dataDetail.Master.Vender_Name = val.vender_name;
                that.dataDetail.Master.Liefer_Adress = val.vender_addr
            },
            // 修改选中状态
            changeSelectStatus(val){
                console.log(val)
                let that = this
                if(val.row.Status == 1){
                    that.dataDetail.Master.Scheme_No = val.row.Scheme_No
                    let index = val.$index
                    for(let i=0;i<that.dataDetail.Log_Ship_SchemeList.length;i++){
                        if(i != index){
                            that.dataDetail.Log_Ship_SchemeList[i].Status = 0
                        }
                    }
                }
            },
            expAuditStatus(val){
                let that = this
                if(val == 0){
                    return '未审'
                } else if(val == 1){
                    return '已审'
                } else if(val == 2){
                    return '驳回'
                } else {
                    return ''
                }
            },
            selectDutyDeptNum(){
                let that = this;
                that.$refs.dutydeptnum.clearInput(true);
            },
            getDutyDeptNum(val) {
                let that = this;
                console.log(val)
                that.dataDetail.Master.Duty_DeptNum = val.num;
                that.dataDetail.Master.Duty_Dept = val.name;
            },
            // 查看文件
            open(url){
                let hrefurl = Common.Url + url;
                window.open(hrefurl);
            },
            changeValue(row, type){
                let that = this
                let index = row.$rowIndex
                if(type == 1){
                    if(that.dataDetail.Log_Order_LineList[index].Actual_Qty != '' && that.dataDetail.Log_Order_LineList[index].Actual_Qty != null){
                        that.dataDetail.Log_Order_LineList[index].line_net_amount = that.$processdata.mathRound4(that.dataDetail.Log_Order_LineList[index].line_net_unitprice * that.dataDetail.Log_Order_LineList[index].Actual_Qty)
                    } else {
                        that.dataDetail.Log_Order_LineList[index].line_net_amount = that.$processdata.mathRound4(that.dataDetail.Log_Order_LineList[index].line_net_unitprice * that.dataDetail.Log_Order_LineList[index].PO_Qty)
                    }
                } else if(type == 2){
                    if(that.dataDetail.Log_Order_LineList[index].Actual_Qty != '' && that.dataDetail.Log_Order_LineList[index].Actual_Qty != null){
                        that.dataDetail.Log_Order_LineList[index].line_total_amount = that.$processdata.mathRound4(that.dataDetail.Log_Order_LineList[index].line_total_unitprice * that.dataDetail.Log_Order_LineList[index].Actual_Qty)
                    } else {
                        that.dataDetail.Log_Order_LineList[index].line_total_amount = that.$processdata.mathRound4(that.dataDetail.Log_Order_LineList[index].line_total_unitprice * that.dataDetail.Log_Order_LineList[index].PO_Qty)
                    }
                } else if(type == 3){
                    if(that.dataDetail.Log_Order_LineList[index].Actual_Qty != '' && that.dataDetail.Log_Order_LineList[index].Actual_Qty != null){
                        that.dataDetail.Log_Order_LineList[index].line_net_amount = that.$processdata.mathRound4(that.dataDetail.Log_Order_LineList[index].line_net_unitprice * that.dataDetail.Log_Order_LineList[index].Actual_Qty)
                        that.dataDetail.Log_Order_LineList[index].line_total_amount = that.$processdata.mathRound4(that.dataDetail.Log_Order_LineList[index].line_total_unitprice * that.dataDetail.Log_Order_LineList[index].Actual_Qty)
                    }
                }
                that.countAmount()
            },
            countAmount(){
                let that = this
                that.total_net_amount = 0
                for(let i = 0;i<that.dataDetail.Log_Order_LineList.length;i++){
                    that.total_net_amount = that.total_net_amount + parseFloat(that.dataDetail.Log_Order_LineList[i].line_net_amount)
                }
                that.total_net_amount = that.$processdata.mathRound4(that.total_net_amount)
            },
            // 一览多选
            handleSelectionChangeView(val){
                let that = this
                that.selectDataView = val
            },
            selectLieferAdress(){
                let that = this;
                let parm = {
                    Code: 'Liefer_Adress'
                }
                that.$refs.lieferadress.clearInput(true,parm);
            },
            getLieferAdress(val){
                let that = this;
                console.log(val)
                that.dataDetail.Master.Liefer_Adress = val.adress;
            },
            selectUnit(){
                let that = this;
                let parm = {
                    Code: 'Unit'
                }
                that.$refs.unit.clearInput(true,parm);
            },
            getUnit(val){
                let that = this;
                console.log(val)
                that.dataDetail.Master.Unit = val.adress;
            },
            selectRemark(row){
                let that = this;
                that.rowindexScheme = row.$index
                let parm = {
                    Code: 'Remark'
                }
                that.$refs.remark.clearInput(true,parm);
            },
            getRemark(val){
                let that = this;
                console.log(val)
                that.dataDetail.Log_Ship_SchemeList[that.rowindexScheme].Remark = val.adress;
            },
            selectExport_import(row){
                let that = this;
                that.rowindexScheme = row.$index
                let parm = {
                    Code: 'Export_import'
                }
                that.$refs.export_import.clearInput(true,parm);
            },
            getExport_import(val){
                let that = this;
                that.dataDetail.Log_Ship_SchemeList[that.rowindexScheme].Export_import = val.adress;
            },
            selectCabinet_Type(row){
                let that = this;
                that.rowindexScheme = row.$index
                let parm = {
                    Code: 'Cabinet_Type'
                }
                that.$refs.cabinet_type.clearInput(true,parm);
            },
            getCabinet_Type(val){
                let that = this;
                that.dataDetail.Log_Ship_SchemeList[that.rowindexScheme].Cabinet_Type = val.adress;
            },
            selectTraffic_Agent(row){
                let that = this;
                that.rowindexScheme = row.$index
                let parm = {
                    Code: 'Traffic_Agent'
                }
                that.$refs.traffic_agent.clearInput(true,parm);
            },
            getTraffic_Agent(val){
                let that = this;
                that.dataDetail.Log_Ship_SchemeList[that.rowindexScheme].Traffic_Agent = val.adress;
            },
            selectTraffic_Clause(row){
                let that = this;
                that.rowindexScheme = row.$index
                let parm = {
                    Code: 'Traffic_Clause'
                }
                that.$refs.traffic_clause.clearInput(true,parm);
            },
            getTraffic_Clause(val){
                let that = this;
                that.dataDetail.Log_Ship_SchemeList[that.rowindexScheme].Traffic_Clause = val.adress;
            },
            selectFirst_Forwarder(row){
                let that = this;
                that.rowindexScheme = row.$index
                let parm = {
                    Code: 'First_Forwarder'
                }
                that.$refs.first_forwarder.clearInput(true,parm);
            },
            getFirst_Forwarder(val){
                let that = this;
                that.dataDetail.Log_Ship_SchemeList[that.rowindexScheme].First_Forwarder = val.adress;
            },
            // 撤回
            recall(){
                let that = this
                let parm = that.dataDetail.Master
                that.$http.urlpost('/LogShip/OrderReCall', parm , function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        if (that.code != '') {
                            that.getDetail(that.code);
                        }
                    }
                });
            },
            // 邮件通知
            email(){
                let that = this
                let parm = that.dataDetail.Master
                that.$http.urlpost('/LogShip/LogShipNoticeLog', parm , function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        if (that.code != '') {
                            that.getDetail(that.code);
                        }
                    }
                });
            },
            copy(){
                let that = this
                this.$confirm(that.$t('getapi[13076]'), that.$t('getapi[194]'), {//'确定复制单据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.addoredit = 1;
                        that.code = ''
                        that.dataDetail.Master.Doc_No = ''
                        that.dataDetail.Master.Exclusively_ID=0
                        that.dataDetail.Master.Status= 0
                        that.dataDetail.Master.UCStatus = 0
                        that.dataDetail.Master.IsEdit = 1,
                        that.dataDetail.Master.Audit_Person = '',
                        that.dataDetail.Master.Modify_Person='',
                        that.dataDetail.Master.Modify_Time='',
                        that.dataDetail.Master.Submit_Person='',
                        that.dataDetail.Master.Submit_Time='',
                        that.dataDetail.Master.Create_Person='',
                        that.dataDetail.Master.Create_Person_Dept='',
                        that.dataDetail.Master.Create_Time='',
                        that.dataDetail.DTAuditInfo = []
                        that.dataDetail.Log_Ship_SchemeList= []
                        that.dataDetail.Log_Ship_UnusualCostList= []
                        that.dataDetail.Log_Order_LineList= []
                        that.dataDetail = {...that.dataDetail};
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            },
            // 新增异常费用
            addunline(){
                let that = this
                that.dataDetail.Log_Ship_UnusualCostList = [...that.dataDetail.Log_Ship_UnusualCostList,{
                    Exclusively_ID: 0,
                    Relation_IID: that.dataDetail.Master.Exclusively_ID,
                    Create_Person: that.user,
                    Create_Time: '',
                    Status: 0,
                    Audit_Time: '',
                    Unusual_Remark: '',
                    Unusual_Cost: '',
                    Unusual_Cost_Currency: '',
                    Unusual_Cost_Url: '',
                    Unusual_Cost_Time: ''
                }]
            },
            // 删除异常费用
            delunline(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let ids = ''
                        for (let i = that.selectunData.length - 1; i >= 0; i--) {
                            that.dataDetail.Log_Ship_UnusualCostList.splice(that.selectunData[i].index, 1);
                            if(that.selectunData[i].Exclusively_ID!=0){
                                ids = ids + that.selectunData[i].Exclusively_ID + ',';
                            }
                        }
                        if(ids != ''){
                            ids = ids.substring(0, ids.length -1)
                            let parm = {
                                ids: ids,
                                LangType:that.$processdata.getLang()
                            }
                            that.$http.urlpost('/LogShip/DelLogShipUnusualCostID', parm , function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //保存异常费用
            saveun(){
                let that = this
                let parm = that.dataDetail.Log_Ship_UnusualCostList
                that.$http.urlpost('/LogShip/SaveLogShipUnusualCost', parm , function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        if (that.code != '') {
                            that.getDetail(that.code);
                        }
                    }
                });
            },
            // 新增审核人
            addauditer(){
                let that = this
                that.dataDetail.DTAuditInfo = [...that.dataDetail.DTAuditInfo,{
                    Exclusively_ID: 0,
                    Relation_IID: that.dataDetail.Master.Exclusively_ID,
                    Sort: '',
                    Audit_Type: '',
                    Audit_Person: '',
                    userID: '',
                    Audit_Status: 0,
                    Audit_Date: '',
                    Audit_Msg: '',
                    superior_flag: 0,
                    Unusual_Flag: false,
                    LangType: 0
                }]
            },
            // 删除审核人
            delauditer(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let ids = ''
                        for (let i = that.selectDataAuditer.length - 1; i >= 0; i--) {
                            that.dataDetail.DTAuditInfo.splice(that.selectDataAuditer[i].index, 1);
                            if(that.selectDataAuditer[i].Exclusively_ID!=0){
                                ids = ids + that.selectDataAuditer[i].Exclusively_ID + ',';
                            }
                        }
                        if(ids != ''){
                            ids = ids.substring(0, ids.length -1)
                            let parm = {
                                ids: ids,
                                LangType:that.$processdata.getLang()
                            }
                            that.$http.urlpost('/LogShip/DelLogShipAuidtInfoByID', parm , function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //保存审核人
            saveauditer(){
                let that = this
                let parm = that.dataDetail.DTAuditInfo
                that.$http.urlpost('/LogShip/SaveAuditinfo', parm , function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        if (that.code != '') {
                            that.getDetail(that.code);
                        }
                    }
                });
            },
            selectAuditer(row){
                let that = this
                that.rowindexAuditer = row.$index
                that.$refs.auditer.clearInput(true);
            },
            getAuditer(data){
                let that = this
                console.log(data)
                that.dataDetail.DTAuditInfo[that.rowindexAuditer].Audit_Person = data.name
                that.dataDetail.DTAuditInfo[that.rowindexAuditer].userID = data.code
                that.dataDetail.DTAuditInfo[that.rowindexAuditer].Audit_Type = 1
            },
            checkDataChange(){
                let that = this
                //能打开此页面即拥有保存权限
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Log_Ship_SchemeList.length;i++){
                    delete datacopy.Log_Ship_SchemeList[i]['index']
                }
                for(let i = 0;i<datacopy.Log_Order_LineList.length;i++){
                    delete datacopy.Log_Order_LineList[i]['_XID']
                }
                for(let i = 0;i<datacopy.Log_Ship_UnusualCostList.length;i++){
                    delete datacopy.Log_Ship_UnusualCostList[i]['index']
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    /deep/.el-upload-list{
        display:none
    }
    /deep/ .blue {
        background: #ABC8FF;
    }
    /deep/ .hidden {
        display: none;
    }
</style>
